module.exports = __webpack_public_path__ + "img/idea_img7.e0016070.png";